export const EXPORT_FORMATS = ["pdf", "xlsx", "csv"] as const;

export type ExportFormat = (typeof EXPORT_FORMATS)[number];

export interface ExportFormatDetail {
  value: ExportFormat;
  label: string;
  description: string;
  extension: string;
  mimeType: string;
  icon: string;
}

/**
 * Visualização atual de uma listagem: o título da tela, as colunas visíveis na
 * ordem em que aparecem e o conjunto completo do resultado consultado, já na
 * ordenação aplicada em tela (RN003).
 */
export interface TableView {
  fileName: string;
  title: string;
  columns: string[];
  rows: string[][];
}

export interface ExportTableViewParams {
  format: ExportFormat;
  view: TableView;
}

const PDF_FORMAT_DETAIL: ExportFormatDetail = {
  value: "pdf",
  label: "PDF",
  description: "Formato .pdf",
  extension: "pdf",
  mimeType: "application/pdf",
  icon: "pi pi-file-pdf",
};

/** Seção "Selecione o formato de saída" do modal Exportar Tabela (RN002). */
export const EXPORT_FORMAT_DETAILS: ExportFormatDetail[] = [
  PDF_FORMAT_DETAIL,
  {
    value: "xlsx",
    label: "Planilha Excel",
    description: "Formato .xlsx",
    extension: "xlsx",
    mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    icon: "pi pi-table",
  },
  {
    value: "csv",
    label: "Texto Separado",
    description: "Formato .csv",
    extension: "csv",
    mimeType: "text/csv;charset=utf-8",
    icon: "pi pi-file",
  },
];

export function isExportFormat(value: string): value is ExportFormat {
  return EXPORT_FORMATS.some((format) => format === value);
}

export function findExportFormatDetail(format: ExportFormat): ExportFormatDetail {
  return EXPORT_FORMAT_DETAILS.find((detail) => detail.value === format) ?? PDF_FORMAT_DETAIL;
}
